import { server } from "../store.js";
import axios from "axios";


export const login=(email,password)=>async(dispatch)=>{
    try{
        dispatch({type:"loginRequest"});
        const {data} = await axios.post(`${server}/login`,{email,password},{
            headers:{
                "Content-Type":"application/json"
            },withCredentials: true,
        }
        );
        dispatch({type:'loginSuccess',payload:data});
    }catch(error){
        dispatch({type:'loginFail',payload:error.response.data.message});
    }
}


export const loadUser=()=>async(dispatch)=>{
    try{
        dispatch({type:"loadUserRequest"});
        const {data} = await axios.get(`${server}/me`,{
            withCredentials: true,
        }
        );
        dispatch({type:'loadUserSuccess',payload:data.user});
    }catch(error){
        dispatch({type:'loadUserFail',payload:error.response.data.message});
    }
}

export const logout=()=>async(dispatch)=>{
    try{
        dispatch({type:"logoutRequest"});
        const {data} = await axios.get(`${server}/logout`,{
            withCredentials: true,
        }
        );
        dispatch({type:'logoutSuccess',payload:data.message});
    }catch(error){
        dispatch({type:'logoutFail',payload:error.response.data.message});
    }
}


export const register=(formdata)=>async(dispatch)=>{
    try{
        dispatch({type:"registerRequest"});
        const {data} = await axios.post(`${server}/register`,formdata,{
            headers:{
                "Content-Type":"multipart/form-data"
            },withCredentials: true,
        }
        );
        dispatch({type:'registerSuccess',payload:data});
    }catch(error){
        dispatch({type:'registerFail',payload:error.response.data.message});
    }
}


export const addToPlaylist = id => async dispatch => {
    try{
        dispatch({type:'addToPlaylistRequest'});
        const config = {
            headers:{
                'Content-type':'application/json',
            },
            withCredentials: true,
        }
        const {data} = await axios.post(
            `${server}/addtoplaylist`,{
                id},config         
        );
        dispatch({type:'addToPlaylistSuccess',payload:data.message});
    }catch(error){
        dispatch({
            type: 'addToPlaylistFail',
            payload: error.response.data.message,
        });
    }
};

export const removeFromPlaylist = id => async dispatch => {
    try{
        dispatch({type:'removeFromPlaylistRequest'});
        const config = {
            withCredentials: true,
        }
        const {data} = await axios.delete(
            `${server}/removefromplaylist?id=${id}`,config         
        );
        dispatch({type:'removeFromPlaylistSuccess',payload:data.message});
    }catch(error){
        dispatch({
            type: 'removeFromPlaylistFail',
            payload: error.response.data.message,
        });
    }
};